export { default } from './DataFieldCDS';
